export default "__VITE_ASSET__BPLpjCX8__"